import { getText } from '../../internal/TextLabels'

export const shouldUsernameEqualEmail = (username, email) =>
  username.includes('@') && email.length && email !== username

const isUsernameInvalid = username => {
  const regExp = /[^-\w@.]/gi
  return regExp.test(username)
}

export const validateUsername = (username, email) => {
  if (isUsernameInvalid(username)) {
    return getText('user.add.invalidUserName')
  }
  if (shouldUsernameEqualEmail(username, email)) {
    return getText('user.add.usernameMustMatchEmail')
  }
  return null
}
